var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerPortrait9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.4583in",
    height: "1.4587in",
    viewBox: "0 0 37.042 37.05",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 7,
    gradientTransform: "matrix(0 0 0 0 -192.32 38.642)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#b3a995",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 54.811,
    x2: 91.853,
    y1: 32.815,
    y2: 32.815,
    gradientTransform: "translate(-54.812,-14.29)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(0 0 0 0 -123.69 -377.74)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4f4b41",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientTransform: "matrix(0 0 0 0 -114.97 -519.46)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7e7867",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 73.177,
    x2: 91.343,
    y1: 38.496,
    y2: 38.496,
    gradientTransform: "matrix(1.3369 0 0 .74799 -91.454 -5.34)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 123.3,
    x2: 133.54,
    y1: 23.39,
    y2: 23.39,
    gradientTransform: "matrix(.79342 0 0 1.2604 -91.454 -5.34)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 143.66,
    x2: 153.9,
    y1: 23.396,
    y2: 23.396,
    gradientTransform: "matrix(.79342 0 0 1.2604 -91.454 -5.34)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 170.29,
    x2: 175.82,
    y1: 18.811,
    y2: 18.811,
    gradientTransform: "matrix(.57451 0 0 1.7406 -91.454 -5.34)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 207,
    x2: 212.54,
    y1: 18.816,
    y2: 18.816,
    gradientTransform: "matrix(.57451 0 0 1.7406 -91.454 -5.34)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82.772 -114.66)",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 215.9,
    height: 279.4,
    fill: "#fcfcfc",
    style: {
      paintOrder: "markers fill stroke"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.0000031738,
    y: 0.0000036621,
    width: 37.042,
    height: 37.042,
    ry: 2.0045,
    fill: "url(#h)",
    style: {
      fill: "url(#h)",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.548 23.45a12.143 12.143 0 0 0-6.0999 1.6268 12.143 12.143 0 0 0-6.0715 10.517v1.4449h24.287v-1.4449a12.143 12.143 0 0 0-6.0715-10.517 12.143 12.143 0 0 0-6.0441-1.6268z",
    fill: "url(#g)",
    stopColor: "#000000",
    style: {
      fill: "url(#g)",
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.548 23.33a10.82 10.82 0 0 0-5.0172 1.2202 6.3735 5.9076 0 0 0 4.9924 2.2356 6.3735 5.9076 0 0 0 4.9919-2.2356 10.82 10.82 0 0 0-4.967-1.2202z",
    fill: "#968c77",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15.274 22.44c-0.42902 0-0.77411 0.34561-0.77411 0.77463v0.82218c0 0.025 5e-3 0.0485 7e-3 0.0729-0.73113 0.28277-1.471 0.63217-2.0588 0.97151-3.7571 2.1693-6.0716 6.1782-6.0715 10.517v1.4449h7.6052l1.6888-12.231 0.14469-0.96583v-0.0827l0.0119-0.0863c-4e-3 1e-3 -8e-3 3e-3 -0.0119 4e-3v-1.2402zm5.9505 0v1.2397c-4e-3 -1e-3 -8e-3 -2e-3 -0.0114-3e-3l0.0114 0.0822v0.0868l0.14521 0.96584 1.6883 12.231h7.6057v-1.4449c1e-4 -4.3384-2.3143-8.3474-6.0715-10.517-0.58772-0.33928-1.3278-0.68878-2.0588-0.97152 2e-3 -0.0243 7e-3 -0.0479 7e-3 -0.0729v-0.82225c0-0.42903-0.34561-0.77463-0.77463-0.77463z",
    fill: "#d3cdc3",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), /*#__PURE__*/React.createElement("rect", {
    x: 15.816,
    y: 18.78,
    width: 5.409,
    height: 7.7654,
    ry: 2.7045,
    fill: "#968c77",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.88 13.33a3.1158 3.1158 0 0 1 3.1158-3.1158v3.1158z",
    fill: "#413e35",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 0.544
  })), /*#__PURE__*/React.createElement("path", {
    d: "m12.56 9.7213a3.5454 3.5803 0 0 0-0.95085 0.96021h-1.0211v1.0306a3.5454 3.5803 0 0 0-1.5736 1.589h1.5736v1.9142a1.4079 1.5556 0 0 0 1.4082 1.5557v-3.4698h0.56379zm12.485 0.96021v6.0894a1.4079 1.5556 0 0 0 1.4082-1.5557v-4.5338z",
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      strokeWidth: 1.0049
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.247,
    y: 6.35,
    width: 14.547,
    height: 16.552,
    ry: 7.2734,
    fill: "#968c77",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.986,
    cy: 15.18,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.986,
    cy: 15.18,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.058,
    cy: 15.18,
    rx: 2.0398,
    ry: 1.4861,
    fill: "#d3cdc3",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.058,
    cy: 15.18,
    rx: 0.885,
    ry: 1.2626,
    fill: "#413e35",
    stopColor: "#000000",
    style: {
      fontVariationSettings: "normal",
      paintOrder: "normal"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m7.992 6.25a5.6891 5.6891 0 0 0 5.6891 5.689 8.3845 5.6891 0 0 0 7.3169-2.9114 4.8129 4.8816 0 0 0 4.8023 4.5589v-2.8489h0.65267a4.4246 4.4877 0 0 0-4.3873-4.4871 8.3845 5.6891 0 0 1 0-5.3e-4h-8.3845z",
    fill: "#413e35",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 24.14a12.143 12.143 0 0 0-2.0516 0.94206 12.143 12.143 0 0 0-6.0715 10.517v1.4449h8.123z",
    fill: "url(#f)",
    stopColor: "#000000",
    style: {
      fill: "url(#f)",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 0.544
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.528 24.15a12.143 12.143 0 0 1 2.0516 0.94206 12.143 12.143 0 0 1 6.0715 10.517v1.4449h-8.123z",
    fill: "url(#e)",
    stopColor: "#000000",
    style: {
      fill: "url(#e)",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 0.544
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.559 27.4a12.143 12.143 0 0 0-3.1817 8.1948v1.4449h3.1817z",
    fill: "url(#d)",
    stopColor: "#000000",
    style: {
      fill: "url(#d)",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 0.544
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.468 27.41a12.143 12.143 0 0 1 3.1817 8.1948v1.4449h-3.1817z",
    fill: "url(#c)",
    stopColor: "#000000",
    style: {
      fill: "url(#c)",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: 0.544
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerPortrait9);
export default __webpack_public_path__ + "static/media/player-portrait-9.4c2bffb6453a96b7d16fc234d78797e9.svg";
export { ForwardRef as ReactComponent };